<template>
  <span>
    <a v-if="already" class="paper-active" @click="enterPaper">开始估分</a>
    <span v-else class="paper-active">{{diffTime}}</span>
  </span>
</template>
<script>
const searchString = window.location.search
export default {
  name: 'count-down',
  props: ['deadline', 'paperId'],
  mounted () {
    if (this.deadline < new Date().getTime()) {
      this.already = true
    }
    this.countdown()
  },
  data () {
    return {
      diffTime: null,
      already: false,
      searchString: searchString
    }
  },
  methods: {
    countdown () {
      this.getDiffTime()
      if (this.already) {
        return false
      }
      setTimeout(() => {
        this.countdown()
      }, 1000)
    },
    enterPaper () {
      this.$addFrog('/click/evaluate2019/paper', { paperid: this.paperId })
      setTimeout(() => {
        window.location.href = `/h5/ape-web-homework_estimate/#/papers/${this.paperId}/estimate${this.searchString}`
      }, 200)
    },
    getDiffTime () {
      let seconds = (this.deadline - new Date().getTime()) / 1000
      if (seconds < 0) {
        this.already = true
        return false
      }
      let h = parseInt(seconds / 3600, 10)
      let m = parseInt((seconds % 3600) / 60, 10)
      let s = parseInt((seconds % 3600) % 60, 10)
      let result = this.paddingZero(h) + ' : ' + this.paddingZero(m) + ' : ' + this.paddingZero(s)
      this.diffTime = result
    },
    paddingZero (num) {
      var result = num
      if (result < 10) {
        result = '0' + result
      }
      return result
    }
  }
}
</script>
<style scoped>
.paper-active {
  color: #008AFF;
}
</style>



// WEBPACK FOOTER //
// CountDown.vue?00b4bd3d